import Vue from "vue";

import Swiper, { Autoplay } from 'swiper'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/swiper-bundle.css";

Swiper.use([Autoplay]);
Vue.use(VueAwesomeSwiper);
